import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getFormItems } from '../../../redux/forms/actions';
import styles from './StripeSection.module.scss';
import Modal from '../../layout/modal/Modal';
import { Button, Grid, MenuItem } from '@material-ui/core';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CloseIcon from '@material-ui/icons/Close';
import DateFnsUtils from '@date-io/date-fns';
import dayjs from 'dayjs';
import { saveManualVerification } from '../../../api/Deals/identification/saveManualVerification.api';
import {
	createStripeIdentification,
	cancelStripeIdentification,
	reSendStripEmail,
} from '../../../api/Deals/identification/sendStripeVerification.api';
import { getStripeDocumentUrl } from '../../../api/Deals/identification/sendStripeVerification.api';
import { addMultiplePurchaser } from '../../../api/Agreement/handleMultiplePurchaser.api';
import {
	saveClientInfoData,
	saveClientNamePurchaser,
} from '../../../api/Agreement/handleClientInfo.api';
import { reformatPhoneString2 } from '../../../utils/validatePhoneNumber';
import { checkIdNumber } from '../../../utils/validateForm';
import CustomTextField from '../../layout/customTextField/CustomTextField';
import CustomDateField from '../../layout/customDateField/CustomDateField';
import AddressAutocomplete from '../../addressAutocomplete/AddressAutocomplete';
import { setAlert } from '../../../redux/alerts/action';

const VerificationModal = ({
	// props
	showModal,
	closeModal,
	node,
	getFormItems,
	verification,
	// redux
	identificationForms,
	setAlert,
}) => {
	const fields = identificationForms?.fields;
	const formData = identificationForms?.formData;
	//const selectedClient = verification?.selectedClient;
	let dbInfo = {
		node: node,
		leadId: verification?.leadId,
	};
	const [clientParent, setClientParent] = useState();
	const [section, setSection] = useState(0);
	const [error, setError] = useState({});
	const [forms, setForms] = useState({});
	const [imgFile, setImgFile] = useState();
	const [imgError, setImgError] = useState('');
	const [client, setClient] = useState({});
	const [selectedClient, setSelectedClient] = useState({});
	const isSafariBrowser =
		navigator.userAgent.indexOf('Safari') !== -1 &&
		navigator.userAgent.indexOf('Chrome') === -1;

	useEffect(() => {
		if (verification?.selectedClient) {
			setSelectedClient(verification?.selectedClient);
		} else {
			setSelectedClient({});
		}
	}, [verification]);

	useEffect(() => {
		getFormItems('agreement', 'clientInfo');
	}, []);

	useEffect(() => {
		// Whenver open section === 2 which is manual verification form,
		// It goes through function resetManualFormInfo
		// Becuase, user does not click send button yet, need to reset
		if (section === 2) {
			resetManualFormInfo();
		}
	}, [section]);

	useEffect(() => {
		// When set new client, need to open section 0 which is to select secure verification or manual verification
		// (1) two purchasers from APS =>
		// (2) after first purchaser complets verification =>
		// (3) starts second purchaser verification (Need display very first step of verification)
		setSection(0);
	}, [client]);

	const resetManualFormInfo = () => {
		setImgError('');
		setImgFile({});
		setError({});
		let data = client?.identification?.report?.document;
		console.log('resetManualFormInfo client', client);

		setForms({
			...formData,
			address1: data?.address1 || '',
			address2: data?.address2 || '',
			city: data?.city || '',
			province: data?.province || '',
			postalCode: data?.postalCode || '',
			dateOfBirth: data?.dateOfBirth || '',
			firstName:
				data?.first_name || client?.clientFName || client?.firstName,
			idNumber: data?.idNumber || '',
			lastName:
				data?.last_name || client?.clientLName || client?.lastName,
			idType: data?.type || '',
		});
	};

	useEffect(() => {
		if (formData) setForms(formData);
		if (selectedClient) {
			setClientParent(selectedClient);
			if (node === 'lead') {
				// selectedClient = {clientFName:'',clientLName:'', ... }
				setClient(selectedClient);
			} else {
				let clientKeys = selectedClient && Object.keys(selectedClient);
				if (node === 'agreement') {
					// selectedClient = { -clientOneKey: {clientFName:'',clientLName:'', ...}, -clientTwoKey: {clientFName:'',clientLName:'', ...} }
					for (let i = 0; i < clientKeys.length; i++) {
						const client = selectedClient[clientKeys[i]];
						if (
							client?.identification?.verification?.status !==
								'manually_verified' &&
							client?.identification?.verification?.status !==
								'verified'
						) {
							setClient(client);
							break;
						}
					}
				} else if (node === 'purchaser') {
					// selectedClient = { -clientOnlyKey: {clientFName:'',clientLName:'', ...}}
					setClient(selectedClient?.[clientKeys[0]]);
				}
			}
		}
	}, [selectedClient, showModal]);

	const goToNextPurchaser = (clientId) => {
		let lastObj = clientParent[Object.keys(clientParent).pop()];
		let secondIdentification = lastObj?.identification;
		setClient(lastObj);
		if (
			clientId === lastObj.id ||
			secondIdentification?.verification?.status === 'verified' ||
			secondIdentification?.verification?.status === 'manually_verified'
		) {
			closeModal(200);
		} else {
			let data = secondIdentification?.report?.document;
			setForms({
				address1: data?.address1 || '',
				address2: data?.address2 || '',
				city: data?.city || '',
				province: data?.province || '',
				postalCode: data?.postalCode || '',
				dateOfBirth: data?.dateOfBirth || '',
				firstName: data?.first_name || lastObj?.firstName,
				idNumber: data?.idNumber || '',
				lastName: data?.last_name || lastObj?.lastName,
				idType: data?.type || '',
			});
		}
	};

	const onChangeImgFile = (e) => {
		setImgFile({});
		// onChange for img file
		if (e.target.files.length) {
			const file = e.target.files[0];
			const fileType = file['type'];
			const fileSize = file['size'];
			const validImageTypes = ['image/jpeg', 'image/png'];
			const validImgSize = 4000000; // 4MB
			let displayName = file.name;
			if (!validImageTypes.includes(fileType)) {
				setImgError('Accept only image files upload.');
			} else if (fileSize > validImgSize) {
				setImgError(
					`File size is too big (${validImgSize / 1000000}mb).`
				);
			} else {
				setImgFile({
					fileName:
						displayName.length > 35
							? displayName.substring(0, 32) + '...'
							: displayName,
					preview: URL.createObjectURL(file),
					raw: file,
				});
				setImgError('');
			}
		}
	};

	const onChange = (e) => {
		let name = e.target.name;
		let value = e.target.value;
		if (name === 'idNumber') {
			if (checkIdNumber(value)) {
				setForms({ ...forms, [name]: value });
			}
		} else {
			if (name !== 'address1') {
				if (value === '') {
					setError({
						...error,
						[name]: true,
					});
				} else {
					error && delete error[name];
				}
			}
			setForms({ ...forms, [name]: value });
		}
	};

	const onDateChange = (dateObj) => {
		let name = dateObj?.name;
		let value = dateObj?.value;
		if (!_.isNil(value) && value !== 'Invalid Date') {
			setForms({ ...forms, dateOfBirth: dateObj.value });
			delete error[name];
		}
	};

	const removeFileInfo = () => {
		setImgFile({});
		setImgError('');
	};

	const handleManualVerification = async (e) => {
		e.preventDefault();
		let dbInfoObj = node === 'lead' ? dbInfo : { ...dbInfo, id: client.id };

		let isNameChanged;

		if (!imgFile?.raw) {
			setImgError('Please upload an image file.');
		} else if (_.isEmpty(forms['dateOfBirth'])) {
			setError({ ...error, dateOfBirth: true });
		} else if (_.isEmpty(error) === true && imgFile?.raw) {
			// When form is validated, and correct img file
			if (
				(client?.firstName || client?.clientFName) !==
					forms.firstName ||
				(client?.lastName || client?.clientLName) !== forms.lastName
			) {
				// When user try to change their name after verified
				isNameChanged = true;
			}

			if (
				client?.identification?.verification?.status ===
				'requires_input'
			) {
				// When changing secure verification to manual verification
				cancelStripeIdentification(client, dbInfoObj);
			}
			if (node === 'agreement') {
				if (isNameChanged) {
					setAlert(
						'warning',
						'Verification name and name on APS do not equal each other, please fix'
					);
				} else {
					// BUG WHEN 2 clients ******2. for APS : saveManualVerification(callback) => Move to step 2(lot selection)
					saveManualVerification(
						imgFile,
						forms,
						dbInfoObj,
						isNameChanged,
						(returned) => {
							if (returned) {
								setAlert('success', 'Successfully Updated');
								goToNextPurchaser(dbInfoObj.id);
							} else {
								setAlert('warning', 'Please try again');
							}
						}
					);
				}
			} else {
				// 3. for Lead, Deal modal (Ok)
				saveManualVerification(
					imgFile,
					forms,
					dbInfoObj,
					isNameChanged,
					(returned) => {
						if (returned) {
							setAlert('success', 'Successfully Updated');
						} else {
							setAlert('warning', 'Please try again');
						}
						closeVerificationModal();
					}
				);
			}
		}
	};
	const handleReSendStripeEmail = () => {
		let isFailed =
			selectedClient?.identification?.verification?.status ===
				'document_err' ||
			selectedClient?.identification?.verification?.status ===
				'selfie_err'
				? true
				: false;
		reSendStripEmail(selectedClient, dbInfo, isFailed);
		console.log('handleReSendStripeEmail', selectedClient, isFailed);
		closeVerificationModal();
	};
	const handleCreateStripe = () => {
		let dbInfoObj = node === 'lead' ? dbInfo : { ...dbInfo, id: client.id };
		if (node === 'agreement') {
			createStripeIdentification(selectedClient, dbInfoObj);
			goToNextPurchaser(client?.id);
		} else {
			createStripeIdentification(selectedClient, dbInfoObj);
			closeVerificationModal();
		}
	};
	const closeVerificationModal = () => {
		if ((node === 'purchaser' || node === 'lead') && dbInfo?.leadId) {
			closeModal(dbInfo.leadId);
		} else {
			closeModal();
		}
	};
	const verificationStatusText = (param) => {
		switch (param?.status) {
			case 'verified':
				return (
					<span
						className={styles.verifiationText_warning}
						// className={styles.verifiationText_success}
					>
						Last secure verification {param?.date}
					</span>
				);
			case 'manually_verified':
				return (
					<span className={styles.verifiationText_warning}>
						Manually Verified {param?.date}
					</span>
				);
			case 'requires_input':
				return (
					<span className={styles.verifiationText_warning}>
						ID Processing
					</span>
				);
			case 'document_err':
			case 'selfie_err':
				return (
					<span className={styles.verifiationText_error}>
						Failed Secure Verification
					</span>
				);
			default:
				return <></>;
		}
	};
	return (
		<div className={styles.modalStripe}>
			<Modal
				show={showModal}
				close={closeVerificationModal}
				title='Verify User ID'
				wrapperWidth='95%'
				wrapperMax={750}
			>
				<div className={styles.modalWrapper}>
					<div className={styles.modalHeader}>
						{/* header section */}

						<p>
							<span className={styles.modalHeader_name}>
								{client?.clientFName || client?.firstName}
								&nbsp;
								{client?.clientLName || client?.lastName}
							</span>
							&nbsp;
							<span>
								{verificationStatusText(
									client?.identification?.verification
								)}
							</span>
						</p>
						<span className={styles.modalHeader_info}>
							{client?.email || client?.clientEmail}
						</span>
						<span> | </span>
						<span className={styles.modalHeader_info}>
							{reformatPhoneString2(
								client?.clientPhoneNumber || client?.phoneNumber
							)}
						</span>
					</div>
					{/* @TODO: section=0 */}
					{section === 0 && (
						<div className={styles.modalSelection}>
							<div className={styles.btnWrapper}>
								<Button
									className={styles.btn}
									onClick={() => setSection(1)}
									variant='contained'
								>
									Secure Verification
								</Button>
								<Button
									className={styles.btn}
									onClick={() => setSection(2)}
									variant='contained'
								>
									Verify Manually
								</Button>
							</div>
							{node === 'agreement' && (
								<Button
									className={styles.skipBtn}
									onClick={() =>
										goToNextPurchaser(client?.id)
									}
								>
									Skip Verification
								</Button>
							)}
						</div>
					)}
					{/* @TODO: section=1: Secure verification*/}
					{section === 1 && (
						<div className={styles.modalSecure}>
							{[
								'requires_input',
								'document_err',
								'selfie_err',
							].includes(
								selectedClient?.identification?.verification
									?.status
							) ? (
								<>
									{/* Expire url||Re-send: SendStripeVerificationEmail */}
									<p>
										Re-send when url is expired or Re-start
										when previous verification is failed.
									</p>
									<div className={styles.modalBtn_wrapper}>
										<Button
											className={styles.btn_cancel}
											onClick={() => setSection(0)}
										>
											Cancel
										</Button>
										<Button
											className={styles.btn}
											variant='contained'
											onClick={handleReSendStripeEmail}
										>
											Send
										</Button>
									</div>
								</>
							) : (
								<>
									{/* Verify Id: createStripeIdentification) */}
									<p>
										Send an email notification to client for
										secure ID Verification
									</p>
									<div className={styles.modalBtn_wrapper}>
										<Button
											className={styles.btn_cancel}
											onClick={() => setSection(0)}
										>
											Cancel
										</Button>
										<Button
											className={styles.btn}
											variant='contained'
											onClick={() => handleCreateStripe()}
										>
											Send
										</Button>
									</div>
								</>
							)}
						</div>
					)}
					{section === 2 && (
						<div className={styles.modalManual}>
							<form
								id='manual-verification-form'
								onSubmit={handleManualVerification}
								method='POST'
							>
								<Grid container spacing={2}>
									{fields?.map((field, index) => {
										if (field.formName === 'idType') {
											return (
												<Grid
													item
													xs={12}
													sm={6}
													key={index}
												>
													<CustomTextField
														formLabel={
															field?.formLabel
														}
														name={field?.formName}
														value={
															forms[
																field?.formName
															] ?? ''
														}
														required
														onChange={(e) =>
															onChange(e)
														}
														type={field?.formType}
														error={
															error[
																field?.formName
															]
														}
														errorMessage={
															field?.errorMessage
														}
														placeholder={
															field?.formLabel
														}
														select
														SelectProps={
															forms?.idType === ''
																? {
																		style: {
																			backgroundColor:
																				'white',
																			color: '#979797',
																			'&.MuiSelectSelect:focus':
																				{
																					backgroundColor:
																						'white',
																				},
																		},
																		MenuProps:
																			{
																				menulistprops:
																					{
																						disablePadding: true,
																					},
																			},
																		displayEmpty: true,
																		renderValue:
																			() =>
																				'Select your ID type',
																  }
																: {
																		style: {
																			backgroundColor:
																				'none',
																			'&.MuiSelectSelect:focus':
																				{
																					backgroundColor:
																						'white',
																				},
																		},
																		MenuProps:
																			{
																				menulistprops:
																					{
																						disablePadding: true,
																					},
																			},
																  }
														}
														menulistprops={{
															disablePadding: true,
														}}
														autoComplete='off'
													>
														<MenuItem
															disabled
															value=''
														>
															Select your ID type
														</MenuItem>
														{field.formName ===
															'idType' &&
															field?.selectItems?.map(
																(item) => (
																	<MenuItem
																		key={
																			item.id
																		}
																		className={
																			styles.idTypeItem
																		}
																		value={
																			item.name
																		}
																	>
																		{
																			item.name
																		}
																	</MenuItem>
																)
															)}
													</CustomTextField>
												</Grid>
											);
										} else if (
											field.formName === 'dateOfBirth'
										) {
											return (
												<Grid
													item
													xs={12}
													sm={6}
													key={index}
												>
													<CustomDateField
														name={'dateOfBirth'}
														formLabel={
															field?.formLabel
														}
														disableFuture={true}
														value={
															forms[
																field?.formName
															]
																? new Date(
																		forms[
																			field
																				?.formName
																		] +
																			'T00:00:00'
																  )
																: null
														}
														onChange={onDateChange}
														error={
															error[
																field?.formName
															]
														}
														errorMessage={
															field?.errorMessage
														}
													/>
												</Grid>
											);
										} else if (
											field.formName === 'address1'
										) {
											return (
												<Grid
													item
													xs={12}
													sm={6}
													key={index}
												>
													<AddressAutocomplete
														formData={forms}
														setFormData={setForms}
														onChange={(e) =>
															onChange(e)
														}
														error={error}
														setError={setError}
														optional={true}
														defaultData={
															client?.address1
																? true
																: false
														}
													/>
												</Grid>
											);
										} else {
											return (
												<Grid
													item
													xs={12}
													sm={6}
													key={index}
												>
													<CustomTextField
														formLabel={
															field?.formLabel
														}
														name={field?.formName}
														value={
															forms[
																field?.formName
															] ?? ''
														}
														type={field?.formType}
														placeholder={
															field?.formLabel
														}
														required={
															field?.required
														}
														onChange={(e) =>
															onChange(e)
														}
														error={
															error &&
															error[
																field?.formName
															] === true
																? true
																: false
														}
														errorMessage={
															field?.errorMessage
														}
													/>
												</Grid>
											);
										}
									})}
									<Grid item xs={12} sm={6}>
										<div
											className={
												styles.modalManual_fileWrapper
											}
										>
											<div
												className={
													styles.modalManual_Info
												}
											>
												{imgError && (
													<span
														className={
															styles.modalManual_fileWarning
														}
													>
														{imgError}
													</span>
												)}
												{imgFile?.fileName && (
													<>
														<span
															className={
																styles.modalManual_fileSuccess
															}
														>
															{imgFile?.fileName}
														</span>
														<div
															className={
																styles.modalManual_closeBtn
															}
															onClick={() =>
																removeFileInfo()
															}
														>
															<CloseIcon />
														</div>
													</>
												)}
											</div>
											<input
												type='file'
												accept='image/*'
												onChange={(e) =>
													onChangeImgFile(e)
												}
												onClick={(e) =>
													(e.target.value = null)
												}
												id='upload-button'
												hidden
												style={{ display: 'none' }}
											/>
											<label htmlFor='upload-button'>
												<div
													className={
														styles.modalManual_uploadBtn
													}
												>
													<CameraAltIcon />
													<span>
														Upload ID Document
													</span>
												</div>
											</label>
											<span className={styles.helerTxt}>
												Accepted image format JPEG or
												PNG (Up to 4MB)
											</span>
										</div>
										{/* @TODO */}
										{/* {imgFile?.preview && (
										<img
											src={imgFile.preview}
											alt='dummy'
											width='250'
											height='auto'
										/>
									)} */}
									</Grid>
								</Grid>

								<div className={styles.modalBtn_wrapper}>
									<Button
										className={styles.btn_cancel}
										onClick={() => setSection(0)}
									>
										Cancel
									</Button>
									<Button
										className={styles.btn}
										variant='contained'
										type='submit'
									>
										Confirm
									</Button>
								</div>
							</form>
						</div>
					)}
				</div>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state) => ({
	identificationForms:
		state.forms.form?.clientInfo?.identification ||
		state.forms.form?.clientDetails?.purchaser?.identification,
	verification: state.verification,
});

export default connect(mapStateToProps, {
	setAlert,
	getFormItems,
})(VerificationModal);
